<template lang="jade">
  .container-fluid
    .row
      .event_main.col-md-12
        header.event_titile_bar.main_title_bar.clearfix
          h1.title.col-md-12.col-sm-10.col-xs-12
            |{{!showGroupConfig ? 'event' : ' Email / SMS'}}
            span.deviceTime.col-md-3.pull-right.no_pad
              |{{deviceTime}}
        //- section.animation.clearfix
        section.animation.clearfix(v-if="showAni")
          .spinner-wrap
            .spinner
              -for (var i =0; i <12; i++)
                i
        .function_group.col-xs-12.col-lg-12.clearfix.no_pad(v-if="!showAni")
          .col-xs-5.no_pad-xs.col-md-5.col-sm-5.event_pagination(v-if="!showGroupConfig")
            .btn-group.col-centered
              button.btn.btn-default(v-on:click="getEvent(1)" v-bind:class="{'focus': pageFocus === 1}")
                span 1
              button.btn.btn-default(v-on:click="getEvent(2)" v-bind:class="{'focus': pageFocus === 2}")
                span 2
          button.config_switch.btn.btn-info.clearfix(v-on:click='showGroupConfig = !showGroupConfig')
            |{{!showGroupConfig ? 'Edit Email/SMS group' : 'Back To Event'}}
        section.event_content.clear-left.clearfix(v-if='!showGroupConfig && !showAni')
          table.table.table-bordered.table-striped.event_mobile_table.hidden-md.hidden-lg
            tr
              th No.
              th Enable
              th Name
              th
            tr(v-for="(key ,event) in events")
              td {{ key }}
              td.enabled
                i.fa.fa-check-square.fa-lg(v-if='event.enabled' v-on:click='setEvent(false, key)')
                i.fa.fa-square-o.fa-lg(v-else v-on:click='setEvent(true, key)')
              td {{ event.name }}
              td
                span(v-on:click='toShowModal(key)')
                  i.fa.fa-edit
          table.table.table-bordered.table-striped.table-hover.event_table.hidden-sm.hidden-xs.col-md-11.col-lg-10.col-centered.hidden-sm.hidden-xs
            tr
              th No.
              th Enable
              th.name Name
              th I/O
              th Event
              th.actions Actions
              th
            tr(v-for="(key, event) in events")
              td {{ key }}
              td.enabled
                i.fa.fa-check-square.fa-lg(v-if='event.enabled' v-on:click='setEvent(false, key)')
                i.fa.fa-square-o.fa-lg(v-else v-on:click='setEvent(true, key)')
              td.name {{event.name}}
              td.source(v-if="returnEventName(event.event) !== 'Ping fail'")
                .col-xs-12.no_pad(v-for="(key, bank) in allBanks" v-if="event.event.source.indexOf(key.toString()) !== -1")
                  span.clearfix(data-bgColor="{{key}}")
                    | {{key === 0 ? 'Input' : 'Outlet' + key}}
              td.source(v-else)
                .col-xs-12.no_pad(v-else)
                  span.clearfix
                    | -
              td.event {{ returnEventName(event.event) }}
              td.action
                span.col_space--xxs(v-for="ac in event.actions")
                  |{{ac.action}}
              td
                span(v-on:click='toShowModal(key)')
                  i.fa.fa-edit.fa-lg
        section.group_editing_section.clear-left.clearfix(v-if='showGroupConfig && !showAni')
          .col-xs-12.col-lg-10.col-centered.row_space--xxs
            tabs
              tab(header='Email')
                .col-md-12
                  table.table.table-striped.table-hover.table-bordered.email_group_table
                    tr
                      th No
                      th Group Name
                      th.hidden-xs.hidden-sm
                        |Emails
                      th
                    tr(v-for="(key, group) in emailData")
                      td {{key}}
                      td {{group.name}}
                      td.hidden-xs.hidden-sm
                        | {{group.accounts}}
                      td
                        i.fa.fa-edit.fa-lg(v-on:click="handleGroupConfig('email', key)")
              tab(header='SMS')
                .col-md-12
                  table.table.table-striped.table-hover.table-bordered.SMS_group_table
                    tr
                      th No
                      th Group Name
                      th.hidden-xs.hidden-sm
                        |Numbers
                      th
                    tr(v-for="(key, group) in SMSData")
                      td {{key}}
                      td {{group.name}}
                      td.hidden-xs.hidden-sm
                        | {{group.accounts}}
                      td
                        i.fa.fa-edit.fa-lg(v-on:click="handleGroupConfig('SMS', key)")
  modal.popout.event_config(
    v-bind:show.sync='showModal'
    v-bind:title='editing.title'
    effect='zoom'
    v-bind:callback='handleEventConfig'
    ok-text="Apply"
    cancel-text="Cancel")
    .modal-body(slot="modal-body")
      table.table.table-bordered.event_config_table
        tr
          th Enable
          td
            .fa_checkbox
              input(type="checkbox" v-model="editing.newEvent.enabled" v-bind:id="'event' + editing.index")
              label(v-bind:for="'event' + editing.index")
        tr
          th Name
          td
            .col-sm-8.col-md-7.col-lg-6.no_pad
              validator(name='eventName')
                input.form-control(type="text" v-model="editing.newEvent.name" maxLength='7' v-validate:name="['engAndNum']")
                span.error(v-if='$eventName.name.invalid && $eventName.name.modified')
                  |English characters , numbers and '_' only
              //- span.error
                validator-errors(v-bind:validation='$eventName')
        tr(v-if="editing.newEvent.key !== 'Ping'")
          th I/O
          td.source.col-xs-10
            v-bank(v-bind:options='sourceOptions'
                   name-prop='source_target'
                   v-bind:output.sync='editing.newEvent.newSource')
        tr
          th Event
          td
            span.col-xs-12.no_pad.event_content.key
              .col-xs-12.no_pad
                v-single-select(v-bind:options='eventOptions'
                              v-bind:value.sync='editing.newEvent.key'
                              placeholder='Please select a key')
              //- v-bank(v-bind:options='eventOptions'
                     v-bind:output.sync='editing.newEvent.key'
                     name-prop='eventKey')
            span.col-xs-12.no_pad.event_content.condition(v-if="editing.newEvent.key === 'Current' || editing.newEvent.key === 'Voltage' || editing.newEvent.key === 'Connection' || editing.newEvent.key === 'Ping'")
              label Condition
              .col-xs-12.no_pad
                v-single-select(v-if="editing.newEvent.key === 'Voltage' || editing.newEvent.key === 'Current'"
                              v-bind:options='conditions'
                              v-bind:value.sync='editing.newEvent.condition'
                              placeholder='Please select a condition')
                v-single-select(v-if="editing.newEvent.key === 'Connection'"
                              v-bind:options='connectOptions'
                              v-bind:value.sync='editing.newEvent.connect'
                              placeholder='Please select a condition')
                v-single-select(v-if="editing.newEvent.key === 'Ping'"
                              v-bind:options='pingOptions'
                              v-bind:value.sync='editing.newEvent.pingCondition'
                              placeholder='Please select a condition')
            span.col-xs-12.no_pad.event_content.float_value(v-if="editing.newEvent.key === 'Current' || editing.newEvent.key === 'Voltage' || editing.newEvent.key === 'Ping'")
              validator(name='newEventFloatValue')
                .col-xs-12.no_pad(v-if="editing.newEvent.key !== 'Ping'")
                  label Value
                .col-xs-4.no_pad(v-if="editing.newEvent.key !== 'Ping'")
                  input.form-control(type='number' v-model='editing.newEvent.float' placeholder='Please enter a value' v-validate:float="['float']" v-el:float-input)
                .col-xs-12.no_pad(v-if="editing.newEvent.key === 'Ping'")
                  label Url/IP
                .col-xs-6.no_pad(v-if="editing.newEvent.key === 'Ping'")
                  input.form-control(type='text' v-model='editing.newEvent.pingAddr' placeholder='google.com / 192.168.15.2' v-validate:url="['ipOrURL']" v-el:url-input)
            //- span.col-xs-12.no_pad.event_content.connect_value(v-if="editing.newEvent.key === 'Connection'")
            //-   label Value
            //-   .col-xs-12.no_pad
            //-     v-single-select(v-bind:options='connectOptions'
            //-                   v-bind:value.sync='editing.newEvent.connect'
            //-                   placeholder='Please select a value')
            span.col-xs-12.no_pad.event_content.power_value(v-if="editing.newEvent.key === 'Power'")
              label Value
              .col-xs-12.no_pad
                v-single-select(v-bind:options='powerOptions'
                              v-bind:value.sync='editing.newEvent.power'
                              placeholder='Please select a value')
        tr
          th Actions
          td.actions
            span.col-xs-12.no_pad.row_space--xxs.clearfix.power_on
              .fa_checkbox.fa_radio
                input(type="checkbox" value='Power ON' id="power_on" v-model='newActions')
                label(for="power_on" v-on:click.prevent="selectPowerTypeAction('Power ON')") Power on
              .bank_group
                v-multi-banks(v-bind:options='sourceOptions'
                            v-bind:output-ary.sync='actions.on.targets'
                            name-prop='power_on_target'
                            v-bind:show-option="newActions.indexOf('Power ON') !== -1")
            span.col-xs-12.no_pad.row_space--xxs.clearfix.power_off
              .fa_checkbox.fa_radio
                input(type="checkbox" value='Power OFF' id="power_off" v-model='newActions')
                label(for="power_off" v-on:click.prevent="selectPowerTypeAction('Power OFF')") Power off
              .bank_group
                v-multi-banks(v-bind:options='sourceOptions'
                            v-bind:output-ary.sync='actions.off.targets'
                            name-prop='power_off_target'
                            v-bind:show-option="newActions.indexOf('Power OFF') !== -1")
            span.col-xs-12.no_pad.row_space--xxs.clearfix.power_reset
              .fa_checkbox.fa_radio
                input(type="checkbox" value='Power RESET' id="power_reset" v-model='newActions')
                label(for="power_reset" v-on:click.prevent="selectPowerTypeAction('Power RESET')") Power reset
              .bank_group
                v-multi-banks(v-bind:options='sourceOptions'
                            v-bind:output-ary.sync='actions.reset.targets'
                            name-prop='power_reset'
                            v-bind:show-option="newActions.indexOf('Power RESET') !== -1")
            span.col-xs-12.no_pad.row_space--xxs.clearfix.sequence_on
              .fa_checkbox.fa_radio
                input(type="checkbox" value='Sequence ON' id="sequence_on" v-model='newActions')
                label(for="sequence_on" v-on:click.prevent="selectPowerTypeAction('Sequence ON')") Sequence on
                  span (From outlet1 to outlet9)
              span(v-if="newActions.indexOf('Sequence ON') !== -1")
                span.row_space--xxs.delay
                  validator(name='seqON')
                    label Delay time(sec)
                    input.form-control(type='number' v-model='actions.sqON.value' v-validate:delay="['int']")
            span.col-xs-12.no_pad.row_space--xxs.clearfix.sequence_off
              .fa_checkbox.fa_radio
                input(type="checkbox" value='Sequence OFF' id="sequence_off" v-model='newActions')
                label(for="sequence_off"  v-on:click.prevent="selectPowerTypeAction('Sequence OFF')") Sequence off
                  span (From outlet1 to outlet9)
              span(v-if="newActions.indexOf('Sequence OFF') !== -1")
                span.row_space--xxs.delay
                  validator(name='seqOFF')
                    label Delay time(sec)
                    input.form-control(type='number' v-model='actions.sqOFF.value' v-validate:delay="['int']")
            //- span.col-xs-12.no_pad.row_space--xxs.clearfix
            //-   span {{emailGroups.selected | json}}
            //-   span {{emailGroups.options | json}}
            span.col-xs-12.no_pad.row_space--xxs.clearfix.email(v-if="emailGroups.options.length !== 0")
              .fa_checkbox
                input(type="checkbox" value='Email' id="email" v-model='newActions' v-bind:checked="editing.actionKeys.indexOf('Email') !== -1")
                label(for="email" v-on:click.prevent="clickGroups('Email')") email
              span.no_pad.col-xs-12.row_space--xxs(v-if="newActions.indexOf('Email') !== -1")
                v-select(
                  v-bind:selected="emailGroups.selected",
                  v-bind:show-labels="true",
                  v-bind:options="emailGroups.options",
                  v-bind:taggable="true",
                  v-bind:multiple="true",
                  v-bind:limit="2",
                  label="label"
                  key="value"
                  @update="updateEmailGroupSelected")
            span.col-xs-12.no_pad.row_space--xxs.clearfix.actionReminding(v-else)
              | You need to have at least 1 valid Email group to set Email action
            span.col-xs-12.no_pad.row_space--xxs.clearfix.SMS(v-if="SMSGroups.options.length !== 0")
              .fa_checkbox
                input(type="checkbox" value='SMS' id="SMS" v-model='newActions' v-bind:checked="editing.actionKeys.indexOf('SMS') !== -1")
                label(for="SMS" v-on:click.prevent="clickGroups('SMS')") SMS
              span.no_pad.col-xs-12.row_space--xxs(v-if="newActions.indexOf('SMS') !== -1")
                v-select(
                  v-bind:selected="SMSGroups.selected",
                  v-bind:show-labels="true",
                  v-bind:options="SMSGroups.options",
                  v-bind:taggable="true",
                  v-bind:multiple="true",
                  v-bind:limit="2",
                  @update="updateSMSGroupSelected"
                  label="label"
                  key="value")
            span.no_pad.col-xs-12.row_space--xxs.actionReminding(v-else)
              | You need to have at least 1 valid SMS group to set SMS action

  modal.popout.group_config(
    v-bind:title='editingGroup.title'
    v-bind:show.sync='showGroupConfigTable'
    effect='zoom'
    v-bind:callback='editingGroup.cb'
    ok-text="Apply"
    cancel-text="Cancel")
    .modal-body.clearfix(slot="modal-body")
      .col-md-6.row_space--xxs
        label Group Name
        br
        span.hint
          |(Use a name different from other group)
        validator(name='groupName')
          input.form-control(v-model="editingGroup.data.name" maxLength='7' v-validate:name="['engAndNum']")
          span.error(v-if='$groupName.name.invalid && $groupName.name.modified')
            |English characters , numbers and '_' only
      .col-md-6.row_space--xxs
        label Group Accouts
        br
        span.hint
          |({{editingGroup.format}})
        textarea(v-model='editingGroup.data.accounts' placeholder="Please use ';' to separate multiple accounts. Empty to disable this group." rows='8').form-control
</template>

<script>
import { modal, tabset, tab } from 'vue-strap'
import _ from 'lodash'
import Multiselect from '../../components/multiselect/Multiselect.vue'
import singleSelect from 'src/components/Single-Select.vue'
import { call } from 'src/Service.js'
import singleBank from 'src/components/Single-Banks.vue'
import multiBanks from 'src/components/Multi-Banks.vue'
import { validate as validEmail } from 'email-validator'
import $ from 'jquery'
import moment from 'moment'
const DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss'

export default {
  components: {
    modal,
    'tabs': tabset,
    tab,
    'v-select': Multiselect,
    'v-single-select': singleSelect,
    'v-bank': singleBank,
    'v-multi-banks': multiBanks
  },
  data () {
    return {
      showAni: true,
      showGroupConfig: false,
      showGroupConfigTable: false,
      editingGroup: {
        _id: '',
        format: '',
        title: '',
        data: {},
        cb: () => {}
      },
      banks: {},
      input: {},
      allBanks: [],
      editing: {
        title: 'Event Config',
        index: '',
        newEvent: {
          name: '',
          enabled: '',
          key: '',
          condition: '',
          newSource: '',
          connect: '',
          power: '',
          float: '',
          pingCondition: 'fail',
          pingAddr: ''
        },
        actionKeys: []
      },
      // ======== options for v-bank ===========
      conditions: [
        {label: '>', value: '>'},
        {label: '>=', value: '>='},
        {label: '=', value: '='},
        {label: '<=', value: '<='},
        {label: '<', value: '<'}
      ],
      eventOptions: [
        {label: 'Current(A)', value: 'Current'},
        {label: 'Voltage(V)', value: 'Voltage'},
        {label: 'Power(W)', value: 'Power'},
        {label: 'Connection', value: 'Connection'},
        {label: 'Ping', value: 'Ping'}
      ],
      connectOptions: [
        {label: 'Get Connection', value: 'ON'},
        {label: 'Lost Connection', value: 'OFF'}
      ],
      powerOptions: [
        {label: 'ON', value: 'ON'},
        {label: 'OFF', value: 'OFF'},
        {label: 'RESET', value: 'RESET'}
      ],
      pingOptions: [
        {label: 'Ping fail', value: 'fail'}
      ],
      // ======== options for v-bank ===========
      events: {},
      showModal: false,
      newActions: [],
      actions: {
        sqOFF: {
          action: 'Sequence OFF',
          targets: ['0', '1', '2', '3'],
          value: '0'
        },
        sqON: {
          action: 'Sequence ON',
          targets: ['0', '1', '2', '3'],
          value: '0'
        },
        reset: {
          action: 'Power Reset',
          targets: []
        },
        on: {
          action: 'Power ON',
          targets: []
        },
        off: {
          action: 'Power OFF',
          targets: []
        }
      },
      // for event config to select
      emailGroups: {
        selected: [],
        options: []
      },
      // for event config to select
      SMSGroups: {
        selected: [],
        options: []
      },
      // for email config table
      emailData: {},
      // for SMS config table
      SMSData: {},
      singleNumberValid: false,
      currentTime: '',
      timezone: {},
      emailGroupMap: {},
      SMSGroupMap: {},
      pageFocus: 1
    }
  }, // close data
  computed: {
    deviceTime () {
      if (this.timezone.useDaylight && moment().isDST()) {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT)
      } else {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT)
      }
    },
    sourceOptions () {
      return Object.keys(this.allBanks).map(idx => {
        return {
          label: idx === '0' ? 'Input' : 'Outlet' + idx,
          value: idx
        }
      })
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    this.showAni = true
    return call(mac, 'dxGetPowerStatus').then(({banks, input}) => {
      this.banks = _.cloneDeep(banks)
      this.input = _.cloneDeep(input)
      this.allBanks = []
      this.allBanks.push(this.input)
      for (let key of Object.keys(this.banks)) {
        this.allBanks.push(this.banks[key])
      }
      return call(mac, 'dxGetEvents', { key: 1 })
    }).then(({entries}) => {
      this.events = _.cloneDeep(entries)
      return call(mac, 'dxGetEmailGroups')
    })
    .then(({entries}) => {
      this.emailGroups = {
        options: [],
        selected: []
      }
      this.emailGroupMap = {}
      for (let key in entries) {
        this.emailGroupMap[key] = entries[key].name
        if (entries[key].accounts.length !== 0) { // only take the group with accounts as a option
          this.emailGroups.options.push({
            label: entries[key].name,
            value: key
          })
        }
      }
      this.emailData = _.cloneDeep(entries)
      return call(mac, 'dxGetSMSGroups')
    })
    .then(({entries}) => {
      this.SMSGroups = {
        options: [],
        selected: []
      }
      this.SMSGroupMap = {}
      for (let key in entries) {
        this.SMSGroupMap[key] = entries[key].name
        if (entries[key].accounts.length !== 0) { // only take the group with accounts as a option
          this.SMSGroups.options.push({
            label: entries[key].name,
            value: key
          })
        }
      }
      this.SMSData = _.cloneDeep(entries)
      return call(mac, 'dxGetTimeZone')
    }).then(({timezone}) => {
      this.timezone = timezone
      this.showAni = false
    }).catch(err => {
      this.alert('danger', 'Error', err.message)
    })
  },
  methods: {
    clickGroups (which) {
      let group = which === 'Email' ? this.emailGroups : this.SMSGroups

      if (this.newActions.indexOf(which) === -1) {
        this.newActions.push(which)
        group.selected = [group.options[0]]
      } else {
        this.newActions.splice(this.newActions.indexOf(which), 1)
        group.selected = []
      }
    },
    updateEmailGroupSelected (value) {
      this.emailGroups.selected = value
    },
    updateSMSGroupSelected (value) {
      this.SMSGroups.selected = value
    },
    selectPowerTypeAction (action) {
      let filter = ['Power ON', 'Power OFF', 'Power RESET', 'Sequence ON', 'Sequence OFF']
      this.newActions = this.newActions.filter(a => a)
      for (let [idx, ac] of this.newActions.entries()) {
        console.log(idx)
        console.log(ac)
        if (filter.indexOf(ac) !== -1) {
          this.newActions[idx] = ''
        }
      }
      this.newActions = this.newActions.filter(a => a)
      this.newActions.push(action)
      console.log(this.newActions)
    },
    getEvent (page) {
      let { mac } = this.$route.params
      this.showAni = true
      call(mac, 'dxGetEvents', { key: page }).then(({entries}) => {
        this.events = _.cloneDeep(entries)
        this.pageFocus = page
        this.showAni = false
      }).catch(err => {
        this.alert('danger', 'Error', 'Unexpect error when initializing the page')
        this.events = []
        this.showAni = false
        console.log(err)
      })
    },
    updateTime () {
      this.currentTime = Date.now()
      let vue = this
      setTimeout(function () {
        vue.updateTime()
      }, 1000)
    },
    isString (param) {
      return typeof param === 'string'
    },
    returnEventName (event) {
      let str = ''
      if (event.key === 'Current' || event.key === 'Voltage') {
        str += event.key + ' '
        str += event.condition + ' '
        str += event.value
      } else if (event.key === 'Power') {
        str += event.key + ' '
        str += event.value
      } else if (event.key === 'Connection') {
        str += event.value === 'ON' ? 'Get Connection' : 'Lost Connection'
      } else if (event.key === 'Ping') {
        str += event.key + ' fail'
      }
      return str
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    toShowModal (key) {
      this.editing.title = 'Event Config ' + key
      this.editing.index = key
      this.editing.event = _.cloneDeep(this.events[key])
      let newE = this.editing.newEvent
      let oldE = this.editing.event
      newE.key = oldE.event.key
      newE.name = oldE.name
      newE.enabled = oldE.enabled
      newE.condition = oldE.event.condition
      newE.newSource = oldE.event.source
      switch (newE.key) {
        case 'Connection':
          newE.connect = oldE.event.value
          break
        case 'Power':
          newE.power = oldE.event.value
          break
        case 'Current':
          newE.float = oldE.event.value
          break
        case 'Voltage':
          newE.float = oldE.event.value
          break
        case 'Ping':
          newE.pingAddr = oldE.event.value
      }
      this.editing.actionKeys = this.editing.event.actions.map((obj) => {
        return obj.action
      })
      this.newActions = _.cloneDeep(this.editing.actionKeys)
      for (let obj in this.editing.event.actions) {
        switch (this.editing.event.actions[obj].action) {
          case 'Power ON':
            this.actions.on.targets = this.editing.event.actions[obj].targets
            break
          case 'Power OFF':
            this.actions.off.targets = this.editing.event.actions[obj].targets
            break
          case 'Power RESET':
            this.actions.reset.targets = this.editing.event.actions[obj].targets
            break
          case 'SMS':
            let selectedSMS = []
            let selectedSMSMap = {}
            for (let opt of this.SMSGroups.options) {
              selectedSMSMap[opt.value] = opt
            }
            for (let tar of this.editing.event.actions[obj].targets) {
              selectedSMS.push(selectedSMSMap[tar])
            }
            this.SMSGroups.selected = _.cloneDeep(selectedSMS)
            break
          case 'Email':
            let selectedEmail = []
            let selectedEmailMap = {}
            for (let opt of this.emailGroups.options) {
              selectedEmailMap[opt.value] = opt
            }
            for (let tar of this.editing.event.actions[obj].targets) {
              selectedEmail.push(selectedEmailMap[tar])
            }
            this.emailGroups.selected = _.cloneDeep(selectedEmail)
            break
          case 'Sequence OFF':
            this.actions.sqOFF.value = this.editing.event.actions[obj].value
            break
          case 'Sequence ON':
            this.actions.sqON.value = this.editing.event.actions[obj].value
            break
        }
      }
      this.showModal = true
    },
    hasSource () {
      // check newSource here
      return this.editing.newEvent.newSource && this.editing.newEvent.newSource.length !== 0
    },
    hasEventValue () {
      // check Event Value exist and valid
      let newE = this.editing.newEvent
      let value = false
      switch (newE.key) {
        case 'Connection':
          value = newE.connect && typeof newE.connect === 'string'
          break
        case 'Power':
          value = newE.power && typeof newE.power === 'string'
          break
        case 'Current':
          value = newE.float && typeof newE.float === 'string' && newE.condition && typeof newE.condition === 'string' && this.$newEventFloatValue.float.valid
          break
        case 'Voltage':
          value = newE.float && typeof newE.float === 'string' && newE.condition && typeof newE.condition === 'string' && this.$newEventFloatValue.float.valid
          break
        case 'Ping':
          // to avoid no reason bug from this.$newEventFloatValue
          value = this.$els.urlInput.className.indexOf('valid') !== -1
          break
      }
      return value
    },
    hasAction () {
      if (this.newActions && this.newActions.length !== 0) {
        return true
      } else {
        return false
      }
    },
    hasValidPowerTypeAction () {
      let counter = 0
      console.log('in valid Power Type action', this.newActions)
      for (let i = 0; i < this.newActions.length; i++) {
        if (this.newActions[i] !== 'Email' && this.newActions[i] !== 'SMS' && this.newActions[i] !== '') counter = counter + 1
      }
      return counter <= 1
    },
    hasTarget () {
      // check Target exist and valid
      let newAc = this.newActions
      let ac = this.actions
      if (newAc.indexOf('Power ON') !== -1 && ac.on.targets.length === 0) return false
      if (newAc.indexOf('Power OFF') !== -1 && ac.off.targets.length === 0) return false
      if (newAc.indexOf('Power RESET') !== -1 && ac.reset.targets.length === 0) return false
      if (newAc.indexOf('Sequence ON') !== -1 && !this.hasSeqValue('on') && ac.sqON.targets.indexOf('') === -1 && ac.sqON.targets.indexOf('0') === -1 && ac.sqON.targets.length !== 3) return false
      if (newAc.indexOf('Sequence OFF') !== -1 && !this.hasSeqValue('off') && ac.sqOFF.targets.indexOf('') === -1 && ac.sqOFF.targets.indexOf('0') === -1 && ac.sqOFF.targets.length !== 3) return false
      if (newAc.indexOf('Email') !== -1 && this.emailGroups.selected.length === 0) return false
      if (newAc.indexOf('SMS') !== -1 && this.SMSGroups.selected.length === 0) return false
      return true
    },
    hasSeqValue (which) {
      if (which === 'on') {
        if (this.actions.sqON.value && this.actions.sqON.value !== '0' && this.actions.sqON.value !== '') return true
      } else if (which === 'off') {
        if (this.actions.sqOFF.value && this.actions.sqOFF.value !== '0' && this.actions.sqOFF.value !== '') return true
      }
      return false
    },
    handleEventConfig () {
      // event name validation
      if (!this.$eventName.valid || this.editing.newEvent.name.trim().length === 0) {
        return this.alert('danger', '', 'Please enter a valid event name')
      }

      // event need a source except 'Connection' and 'Ping'
      if (this.editing.newEvent.key !== 'Connection' && this.editing.newEvent.key !== 'Ping' && !this.hasSource()) {
        console.log(this.editing.newEvent.key)
        return this.alert('danger', '', 'Please give this event a source')
      }

      // event need a valid value
      if (!this.hasEventValue()) return this.alert('danger', '', 'Please complete the event config')

      // event need at least one action
      if (!this.hasAction()) return this.alert('danger', '', 'Please give your config an action')

      // you only can choose one power type action
      if (!this.hasValidPowerTypeAction()) return this.alert('danger', 'You can only select one power related action at a time')

      // event need a target
      if (!this.hasTarget()) return this.alert('danger', '', 'Please give your action a target')

      // sequence value is valid
      if ((this.newActions.indexOf('Sequence ON') !== -1 && this.$seqON.delay.invalid) || (this.newActions.indexOf('Sequence OFF') !== -1 && this.$seqOFF.delay.invalid)) return this.alert('danger', '', 'Please enter a valid delay time with integer')

      console.log('hi everything is fine')
      let newEvent = this.editing.newEvent
      let ac = []

      // ============ to pack actions
      for (let action of this.newActions) {
        switch (action) {
          case 'Power ON':
            ac.push({
              action: action,
              targets: this.actions.on.targets
            })
            break
          case 'Power OFF':
            ac.push({
              action: action,
              targets: this.actions.off.targets
            })
            break
          case 'Power RESET':
            ac.push({
              action: action,
              targets: this.actions.reset.targets
            })
            break
          case 'SMS':
            ac.push({
              action: action,
              targets: this.SMSGroups.selected.map(tar => tar.value)
            })
            break
          case 'Email':
            ac.push({
              action: action,
              targets: this.emailGroups.selected.map(tar => tar.value)
            })
            break
          case 'Sequence OFF':
            ac.push({
              action: action,
              targets: ['0', '1', '2', '3'],
              value: parseInt(this.actions.sqOFF.value).toString() // to avoid zeros in the beginning
            })
            break
          case 'Sequence ON':
            ac.push({
              action: action,
              targets: ['0', '1', '2', '3'],
              value: parseInt(this.actions.sqON.value).toString() // to avoid zeros in the beginning
            })
            break
        }
      }

      // start to pack
      let param = {
        entries: {
          [this.editing.index]: {
            enabled: newEvent.enabled,
            name: newEvent.name.trim(), // trim the ' ' of both sides
            event: {
              key: newEvent.key,
              condition: newEvent.condition,
              value: '',
              source: newEvent.key !== 'Connection' || newEvent.key !== 'Ping' ? newEvent.newSource : null
            },
            actions: ac
          }
        }
      } // close param

      // ============= different key, pack different event
      switch (newEvent.key) {
        case 'Connection':
          param.entries[this.editing.index].event.value = newEvent.connect
          break
        case 'Current':
          param.entries[this.editing.index].event.value = parseFloat(newEvent.float).toString() // to avoid zeros in the beginning
          break
        case 'Voltage':
          param.entries[this.editing.index].event.value = parseFloat(newEvent.float).toString() // to avoid zeros in the beginning
          break
        case 'Power':
          param.entries[this.editing.index].event.value = newEvent.power
          break
        case 'Ping':
          param.entries[this.editing.index].event.value = newEvent.pingAddr
      }

      console.log(param)
      call(this.$route.params.mac, 'dxSetEvents', param).then(res => {
        console.log(res)
        this.showModal = false
      }, err => {
        this.alert('danger', 'Unexpected Error', err)
        console.log(err)
      })
    },
    setEvent (enabled, eventKey) {
      let param = {
        entries: {
          [eventKey]: this.events[eventKey]
        }
      }
      param.entries[eventKey].enabled = enabled
      call(this.$route.params.mac, 'dxSetEvents', param).then(res => {
        console.log(res)
      }, err => {
        this.alert('danger', 'Unexpected Error', err)
        console.log(err)
      })
    },
    handleGroupConfig (type, key) {
      console.log(key)

      if (type === 'email') {
        this.editingGroup._id = key
        this.editingGroup.title = 'Edit email group ' + key
        this.editingGroup.format = 'ex1@gmail.com;ex2@gmail.com'
        this.editingGroup.data = _.cloneDeep(this.emailData[key])
        this.editingGroup.cb = this.emailGpApply
      } else if (type === 'SMS') {
        this.editingGroup._id = key
        this.editingGroup.title = 'Edit SMS group ' + key
        this.editingGroup.format = '+886932123123;+886972456456'
        this.editingGroup.data = _.cloneDeep(this.SMSData[key])
        this.editingGroup.cb = this.SMSGpApply
      }

      this.showGroupConfigTable = true
    },
    checkGroupNameUsed (type) {
      // check if new name is used in this.emailData or this.SMSData
      let data = type === 'email' ? this.emailData : this.SMSData
      for (let key in data) {
        if (key !== this.editingGroup._id && data[key].name === this.editingGroup.data.name) return true
      }
      return false
    },
    checkGroupAccountAvailable (type) {
      // empty would be disable, so let it pass
      if (this.editingGroup.data.accounts.length === 0) {
        return true
      } else {
        let accounts = this.editingGroup.data.accounts.split(';')
        // 怎麼樣回傳都是array ,如果source 裡面沒有';',then will return an array with only one value

        if (type === 'email') {
          for (let email of accounts) {
            if (!validEmail(email)) return 'one of the emails invalid' // single email invalid
          }
        } else if (type === 'SMS') {
          let regex = /^\+{1}[0]{0,1}\d{10,12}/
          for (let number of accounts) {
            if (!regex.test(number)) return 'one of the number invalid' // single number invalid
          }
        }

        return true
      }
    },
    checkGroupAccountOverLimit () {
      return this.editingGroup.data.accounts.split(';').length > 10
    },
    checkGroupCanBeEmpty (type) {
      // 1. Find the editing name as key
      let oldName = type === 'Email' ? this.emailData[this.editingGroup._id].name : this.SMSData[this.editingGroup._id].name
      let newName = this.editingGroup.data.name

      if (oldName === newName) return true

      // 2. Check whether the key is being used in this.events.actions
      for (let key of Object.keys(this.events)) {
        for (let obj of this.events[key].actions) {
          if (obj.action === type && obj.targets.indexOf(oldName) !== -1) return false
        }
      }
      return true
    },
    emailGpApply () {
      // validation
      // 0. check name is vaild
      if (this.$groupName.invalid) return this.alert('danger', '', 'Invalid group name')
      // 1. check if group name is available
      if (this.checkGroupNameUsed('email')) return this.alert('danger', '', 'Group name used')

      // 2. check if this group is being used in any action of this.events
      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('Email')) {
        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before leaving it empty')
      }

      if (!this.checkGroupCanBeEmpty('Email')) {
        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before modifying the name')
      }

      // 3. check if accoutAvailable
      if (typeof this.checkGroupAccountAvailable('email') === 'string') {
        return this.alert('danger', '', this.checkGroupAccountAvailable('email'))
      }

      // 4. check if the amount of the accounts is over limit
      if (this.checkGroupAccountOverLimit()) return this.alert('danger', '', 'Only 10 accounts allowed')

      console.log('hahaha all email good')

      // update the targets name in each event target
      let preName = this.emailData[this.editingGroup._id].name
      let newName = this.editingGroup.data.name
      let newEvents = _.cloneDeep(this.events)
      console.log('preName = ', preName)
      console.log('newName = ', newName)

      for (let key of Object.keys(newEvents)) {
        for (let obj of newEvents[key].actions) {
          if (obj.action === 'Email' && preName !== newName && obj.targets.indexOf(preName) !== -1) {
            obj.targets[obj.targets.indexOf(preName)] = newName
          }
        }
      }

      // remove the ' ' from both sides of the string
      this.editingGroup.data.name = this.editingGroup.data.name.trim()
      // update the root object to activate the Vue to update view
      this.events = newEvents

      // update the group to server
      let param = {
        entries: {
          [this.editingGroup._id]: this.editingGroup.data
        }
      }
      console.log(param)

      call(this.$route.params.mac, 'dxSetEmailGroups', param).then(res => {
        this.showGroupConfigTable = false
      }, err => {
        this.alert('danger', '', err)
      })
    },
    SMSGpApply () {
      // validation
      // 0. check name is vaild
      if (this.$groupName.invalid) return this.alert('danger', '', 'Invalid group name')

      // 1. check if group name is available
      if (this.checkGroupNameUsed('SMS')) return this.alert('danger', '', 'Invalid group name')

      // 2. check if this group is being used in any action of this.events
      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('SMS')) {
        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before leaving it empty')
      }

      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('SMS')) {
        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before modifying the name')
      }

      // 3. check if accoutAvailable
      if (typeof this.checkGroupAccountAvailable('SMS') === 'string') {
        return this.alert('danger', '', this.checkGroupAccountAvailable('SMS'))
      }

      // 4. check if the amount of the accounts is over limit
      if (this.checkGroupAccountOverLimit()) return this.alert('danger', '', 'Only 10 accounts allowed')

      console.log('hahah all number good')

      // update the targets name in each event target
      let preName = this.SMSData[this.editingGroup._id].name
      let newName = this.editingGroup.data.name
      let newEvents = _.cloneDeep(this.events)
      console.log('preName = ', preName)
      console.log('newName = ', newName)

      for (let key of Object.keys(newEvents)) {
        for (let obj of newEvents[key].actions) {
          if (obj.action === 'SMS' && preName !== newName && obj.targets.indexOf(preName) !== -1) {
            obj.targets[obj.targets.indexOf(preName)] = newName
          }
        }
      }

      // remove the ' ' from both sides of the string
      this.editingGroup.data.name = this.editingGroup.data.name.trim()
      // update the root object to activate the Vue to update view
      this.events = newEvents

      // start to update the group to server
      let param = {
        entries: {
          [this.editingGroup._id]: this.editingGroup.data
        }
      }
      console.log(param)
      call(this.$route.params.mac, 'dxSetSMSGroups', param).then(res => {
        this.showGroupConfigTable = false
      }, err => {
        this.alert('danger', '', err)
      })
    },
    handleDeleteGroup (group, tag) {
      let key = this[group].selected.indexOf(tag)
      this[group].selected.splice(key, 1)
    }
  },
  ready () {
    this.updateTime()
  },
  watch: {
    params: 'reloadAsyncData',
    showModal (nv) {
      if (!nv) {
        // $('.fa_radio label').unbind('click')
        $('.event_config').scrollTop(0)
        this.editing = {
          title: 'Event Config',
          index: '',
          newEvent: {
            name: '',
            enabled: '',
            key: '',
            condition: '',
            newSource: '',
            connect: '',
            power: '',
            float: '',
            pingCondition: 'fail',
            pingAddr: ''
          },
          actionKeys: [],
          newActions: []
        }
      }
    },
    showGroupConfigTable (nv) {
      if (!nv) {
        $('.group_config').scrollTop(0)
      }
    },
    showGroupConfig (nv) {
      if (!nv) {
        this.reloadAsyncData()
      }
    },
    emailGroups: {
      deep: true,
      handler: function (nv) {
        if (nv.selected.length === 0 && this.newActions.indexOf('Email') !== -1) {
          this.newActions.splice(this.newActions.indexOf('Email'), 1)
        }
      }
    },
    SMSGroups: {
      deep: true,
      handler: function (nv) {
        if (nv.selected.length === 0 && this.newActions.indexOf('SMS') !== -1) {
          this.newActions.splice(this.newActions.indexOf('SMS'), 1)
        }
      }
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      // update the data when received
      console.log(type)
      console.log(event)
      console.log(msg)
      if (type === 'event') {
        this.events = _.assignIn(this.events, event)
      } else if (type === 'Email') {
        this.emailData = _.assignIn(this.emailData, event)
        // update the emailGroups
        this.emailGroups = {
          options: [],
          selected: []
        }
        for (let key in this.emailData) {
          if (this.emailData[key].accounts.length !== 0) {
            this.emailGroups.options.push({
              label: this.emailData[key].name,
              value: this.emailData[key].name
            })
          }
        }
      } else if (type === 'SMS') {
        this.SMSData = _.assignIn(this.SMSData, event)
        // update the SMSGroups
        this.SMSGroups = {
          options: [],
          selected: []
        }
        for (let key in this.SMSData) {
          if (this.SMSData[key].accounts.length !== 0) {
            this.SMSGroups.options.push({
              label: this.SMSData[key].name,
              value: this.SMSData[key].name
            })
          }
        }
      } else if (type === 'timezone') {
        this.timezone = event.timezone
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
.event_titile_bar{
  h1{
    @include breakpoint(xxs) {
      padding-right: 0px;
    }
  }
}
table th {
  text-align: center;
}
.config_switch{
  padding: 3px 6px;
}
.event_table{
  text-align: center;
  max-width:1000px;
}
.event_mobile_table{
  text-align: center;
}
.function_group{
  padding-top: $space_sm;
  padding-bottom: $space_sm;
  @include breakpoint(xs){
    padding-top: $space_xxs;
    padding-bottom: $space_xxs;
  }
  position: relative;
  .event_pagination{
    margin-bottom: -7px;
    text-align: center;
    .btn{
      outline:none;
    }
    .btn-group{
      & .focus{
        background-color: #4a4b4a;
        color: #fff;
      }
    }
    float:none;
    margin: 0 auto;
    @include breakpoint(xs) {
      float: left;
      margin: inherit;
    }
  }
  .config_switch{
    position: absolute;
    right: 30px;
    top:26px;
    @include breakpoint(xs) {
      position: relative;
      float: right;
      right: initial;
      top: initial;
    }
  }
}
/* ================= pc table ================ */
.event_table{
  td.action{
    span:first-child{
      padding-left: 0;
    }
  }
  td.source{
    min-width: 100px;
    white-space: nowrap;
    text-align: left;
  }
  .source > div{
    span{
      color: darken($outlet_color, 20%);
      border-radius: $base_border_radius;
      // background-color: darken($outlet_color, 20%);
      // border: 1px solid darken($outlet_color, 20%);
    }
  }


}
/* =============== config table =============== */
.event_config_table{
  th {
    text-transform: capitalize;
    text-align: center;
    font-size: 14px;
    @include breakpoint(iFive){
      padding: 5px;
    }
  }
  /* ============ global weekDay and outlets style ==================== */
  .actions, .source{
    width: 100%;
    position: relative;
    span{
      float: left;
      font-size: 10px;
      padding-left: 5px;
      text-transform: capitalize;
    }
    label{
      cursor: pointer;
    }
  }
  .fa_checkbox{
    font-size: 14px;
    @include breakpoint(md){
      font-size: 16px;
    }
    @include breakpoint(lg){
      font-size: 16px;
    }
    span{
      display: inline-block;
      height: 22px;
      line-height: 22px;
      float: right;
      @include breakpoint(xs){
        float: left;
      }
    }
  }
  /* =========== email_group ===================*/
  .email_group,.SMS_group{
    margin-top: -38px;
    & .btn{
      padding: 3px;
    }
  }
  /* =========== source ======================= */
  .source{
    padding-left: 0;
  }
  .bank_checkbox{
    position: absolute;
    left: -9999px;
  }

  /* =========== weekDay ================== */
  .action_checkbox{
    position: absolute;
    left: -9999px;
    &:checked + .action_label{
      background-color: $base_black;
    }
  }
  .action_label,.bank_label{
    width: 100%;
    text-align: center;
    padding: 5px 3px;
    background-color: #d8d8d8;
    color: $base_white;
  }
  .form-control{
    font-size: 12px;
  }
  .tag_group{
    .tag__single{
      border: 1px solid $pri_gray;
      border-radius: $base_border_radius;
      padding: 3px 5px;
      position: relative;
      margin-bottom: 3px;
      margin-right: 3px;
      & .fa{
        cursor: pointer;
        font-size: 14px;
        padding-left: 5px;
      }
    }
  }

  .sequence_on, .sequence_off {
    input[type='number']{
      border: 1px solid $base_gray;
    }
  }

  .enabled {
    position: relative;
    input {
      position: absolute;
      left: -9999px;
    }
    label{
      cursor: pointer;
      padding-left: 25px;
    }
    .fa{
      position: absolute;
      left: 10px;
      top: 11px;
    }
  }

  .actions span.actionReminding {
    color: #f00;
    font-size: 10px;
    text-transform: initial;
  }

} /* close event_config_table */

/* ============ group_editing_section ============== */
.group_editing_section{
  table {
    text-align: center;
  }
}
.group_config{
  & .hint{
    font-size: 12px;
    opacity: .7;
  }
}
/* float styles and sequence values*/
.float_value, .sequence_on .delay, .sequence_off .delay{
  & input[type=number]::-webkit-inner-spin-button,
    & input[type=number]::-webkit-outer-spin-button{
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
    }
    & input[type=number]{
      -moz-appearance: textfield;
    }
}


td.action, td.name,td.source , td.event{
  text-align: left;
  padding-left: 15px;
}
th.name{
  width: 100px;
}
td.name{
  width: 100px;
}

td.action {
  span {
    position: relative;
    &:after{
      display:block;
      position: absolute;
      top: 0;
      right: 0px;
      transform-origin:center;
      transform: rotateZ(15deg);
      width: 2px;
      height: 22px;
      content: '';
      // height: 100%;
      border-right: 1px solid darken($outlet_color, 20%);
    }
    &:nth-last-child(1):after{
      display: none;
    }
  }
}

// loading animation
.animation{
  position: relative;
  text-align: center;
  padding: 80px 1px 1px 1px;
  @include breakpoint(xxs) {
    padding: 30px 1px 1px 1px;
  }
}

.spinner {
  $desktopOffset: 30px;
  $mobileOffset: 20px;
  $basicOpacity: 1 / 12;
  $basicDeg: 30deg;
  // outline: 1px solid #f00;
  height: 100px;
  width: 100px;
  display: block;
  animation: spin 1s steps(12, end) infinite;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  transform-origin:center;
  & i {
    height: 30px;
    width: 6px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    transform-origin: center;
    background: #000;
    box-shadow: 0 0 3px rgba(255, 255, 255, .7);
    border-radius: 3px;
    @for $i from 1 through 12 {
      &:nth-child(#{$i}){transform:rotate(($i - 1) * $basicDeg) translateY($desktopOffset); opacity: $basicOpacity * $i;}
    }
  }
  @include breakpoint(xxs) {
    & i {
      display:block;
      height: 30px;
      width: 4px;
      @for $i from 1 through 12 {
        &:nth-child(#{$i}){transform:rotate(($i - 1) * $basicDeg) translateY($mobileOffset) scale(.6, .6); opacity: $basicOpacity * $i ;}
      }
    }
    & i {
      transform: scale(.3, .3);
    }
  }
}


@keyframes spin {
  from { transform: rotateZ(0deg); }
  to { transform: rotateZ(360deg); }
}


</style>



// WEBPACK FOOTER //
// Event.vue?e0be913c